import image from "./push.svg";
import { FormattedMessage, useIntl } from "react-intl";
import {
  BottomButton,
  BottomButtonContainer,
} from "../../../elements/wrapper/bottomButton.wrapper.jsx";
import { getQueryParams } from "../../../../app/RouteWithSubRoutes";
import IntroImage from "../../introImage.component.jsx";
import StandardHeadline from "../../../elements/text/standardHeadline.text.jsx";
import { pageNames } from "../../../../reduxStore/reducers/main.js";
import { useEffect, useState } from "react";
import ToggleSetting from "../../../elements/buttons/toggleSetting.component.jsx";

export default function Push(props) {
  const onComplete = () => {
    props.history.push(
      `/${pageNames.intro}/${pageNames.complete}/${getQueryParams()}`
    );
  };
  const handleChange = () =>
    props.setProperties({
      pushMessages: {
        userAllowed: !props.properties.pushMessages.userAllowed,
      },
    });
  const intl = useIntl();

  const [permissionText, setPermissionText] = useState("");

  useEffect(() => {
    if (
      props.properties.pushMessages.permissionAllowed !== null &&
      !props.properties.pushMessages.permissionAllowed &&
      props.properties.pushMessages.userAllowed
    ) {
      setPermissionText("System permission is denied");
    }
    if (props.properties.pushMessages.permissionAllowed) {
      setPermissionText(null);
    }
  }, [
    props.properties.pushMessages.permissionAllowed,
    props.properties.pushMessages.userAllowed,
  ]);

  return (
    <BottomButtonContainer
      buttons={[
        new BottomButton(
          () => props.history.goBack(),
          <FormattedMessage id={"search.buttonBack"} />,
          { className: "mr-3 normalButton--naked" }
        ),
        new BottomButton(onComplete, <FormattedMessage id="welcome.next" />, {
          className: "normalButton--primary",
        }),
      ]}
    >
      <IntroImage imageName={"push.svg"} fallbackImage={image} />
      <div className="d-flex flex-column pl-3 pr-3">
        <StandardHeadline className={"mb-2 mt-3"} type={"h2"}>
          <FormattedMessage id="welcome.pushTitle" />
        </StandardHeadline>
        {permissionText ? permissionText : null}
        <ToggleSetting
          settingTitle={intl.formatMessage({
            id: "settings.push.allowPushMessagesTitle",
          })}
          settingText={intl.formatMessage({
            id: "settings.push.allowPushMessagesText",
          })}
          onChange={handleChange}
          toggleValue={
            props.properties.pushMessages.userAllowed &&
            props.properties.pushMessages.permissionAllowed
          }
        />
      </div>
    </BottomButtonContainer>
  );
}
